import _404Template from '../404.html';
import _401Template from '../401.html';
import _pricingErrTemplate from '../pricingError.html';
import routesTemplate from '../routes.html';

export default /* @ngInject */ function routes($routeProvider, $locationProvider, configProvider) {
    $locationProvider.html5Mode(true);

    // Patch $routeProvider.when to first resolve the user.
    $routeProvider.origWhen = $routeProvider.when;
    $routeProvider.when = function() {
        arguments[1].resolve = {
            user: /** @ngInject*/ function(authData) {
                return authData();
            }
        };
        $routeProvider.origWhen.apply($routeProvider, arguments);
    };

    $routeProvider.when('/unauthorised', {
        templateUrl: _401Template,
        title: '401 Unauthorised'
    });

    function goBackFromPricingError() {
        try {
            const referrerHost = new URL(document.referrer).hostname;
            const currentHost = window.location.hostname;
            if (currentHost === referrerHost) {
                window.location.href='https://www.blippar.com/pricing';
            } else {
                window.history.back();
            }
        } catch (err) {
            window.history.back();
        }
    }

    $routeProvider.when('/invalid-email-error', {
        templateUrl: _pricingErrTemplate,
        title: 'You need a valid educational email',
        showEducatorContact: true,
        back: function() {
            goBackFromPricingError();
        }
    });

    $routeProvider.when('/plan-error', {
        templateUrl: _pricingErrTemplate,
        title: 'Failed to lookup plan',
        showEducatorContact: true,
        back: function() {
            goBackFromPricingError();
        }
    });

    $routeProvider.when('/payment-error', {
        templateUrl: _pricingErrTemplate,
        title: 'There was an error processing your group payment',
        back: function() {
            goBackFromPricingError();
        }
    });

    $routeProvider.when('/payment-already-initiated', {
        templateUrl: _pricingErrTemplate,
        title: 'Payment has already been initiated for this group',
        back: function() {
            goBackFromPricingError();
        }
    });

    if (configProvider.debug) {
        $routeProvider.when('/routes', {
            templateUrl: routesTemplate,
            controllerAs: 'routing',
            title: 'Routes',
            controller: /* @ngInject */ function(user) {
                this.user = user;
            }
        });
    }

    $routeProvider.otherwise({
        templateUrl: _404Template,
        title: '404 Page not found'
    });
}



// WEBPACK FOOTER //
// ./config/routes.js